import { gql } from '@/__generated__';

/**
 * Mutation: Upload Device Document (Phase 1)
 * 
 * Initiates file upload session by generating a presigned S3 URL.
 * The file should be uploaded directly to S3 by the client.
 * After successful upload to S3, call confirmDeviceDocumentUpload mutation.
 * 
 * @param deviceId - Device ID (string identifier)
 * @param documentType - Type of document (ELECTRICAL_PLAN or DIAGRAM)
 * @param contentType - MIME type of the file (e.g., 'application/pdf')
 * 
 * @returns UploadSession with presigned URL and file key for confirmation
 */
const UPLOAD_DEVICE_DOCUMENT = gql`
  mutation UploadDeviceDocument(
    $deviceId: String!
    $documentType: DeviceDocumentType!
    $contentType: String!
  ) {
    uploadDeviceDocument(
      deviceId: $deviceId
      documentType: $documentType
      contentType: $contentType
    ) {
      sessionId
      uploadUrl
      fileKey
      finalUrl
      expiresAt
    }
  }
`;

export default UPLOAD_DEVICE_DOCUMENT;
